import { abortAtom } from './abortAtom';
import { alertAtom } from './alertAtom';
import { confirmAtom } from './confirmAtom';
import { ifSwitchAtom } from './ifSwitchAtom';
import { invokeComponentMethodAtom } from './invokeComponentMethodAtom';
import { invokeDataSourceMethodAtom } from './invokeDataSourceMethodAtom';
import { messageAtom } from './messageAtom';
import { promptAtom } from './promptAtom';
import { runScriptAtom } from './runScriptAtom';
import { sleepAtom } from './sleepAtom';
import { validateFormAtom } from './validateFormAtom';
import { parallelAtom } from "../../../lib/builtin/flowAtoms/parallelAtom";
// eslint-disable-next-line @typescript-eslint/naming-convention
export const builtinFlowAtoms = [alertAtom, confirmAtom, promptAtom, messageAtom, validateFormAtom, ifSwitchAtom, runScriptAtom, invokeComponentMethodAtom, invokeDataSourceMethodAtom, sleepAtom, abortAtom, parallelAtom];
//# sourceMappingURL=index.js.map
